import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'] 
})
export class NavMenuComponent {
  isExpanded = false;
  tab: number = 1;
  url: string;
  activeTab: string;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  constructor() {
    this.url = window.location.href;
    this.activeTab = this.url.substring(this.url.lastIndexOf("/") + 1);

    switch (this.activeTab.toLowerCase()) {
      case "home": {
        this.tab = 1;
        break;
      }
      case "about": {
        this.tab = 2;
        break;
      }
      case "technology": {
        this.tab = 3;
        break;
      }
      case "tech-clients": {
        this.tab = 3;
        break;
      }
      case "the-fa":
      case "institute-of-physics":
      case "chambers-and-partners":
      case "childrens-society":
      case "tesco":
      case "virgin-games":
      case "xm-london":
      case "qca":
      case "datamonitor":
      case "demon-internet":
      {
        this.tab = 3;
        break;
      }
      default: {
        this.tab = 1; 
        break;
      }
    } 
  }
}
